import * as React from "react";
import { useState, useEffect } from "react";
import {  Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import SimpleCard from "../../../Common/SimpleCard";
import axios from "../../../utils/http";
import { APP_LIST_PEND } from "../../../utils/urls";

import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useHistory } from "react-router";
import Header from "../../../Common/header";
import Loader from "../../../Common/Loader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxRoot: {
      "@media (min-width: 1280px)": {
        height: "100vh",
        padding: "20px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "100vh",
        padding: "20px",
      },
      [theme.breakpoints.between("sm", "md")]: {
        height: "100vh",
        padding: "20px",
      },
    },
    root: {
      flexGrow: 1,
      padding: "10px",
    },
  })
);

export default function Pending() {
  const history = useHistory();

  const [data, setData] = useState<any>([]);
  const [loader, setLoader] = useState(true);

  const classes = useStyles();

  useEffect(function () {
    axios
      .get(APP_LIST_PEND)
      .then((response) => {
        setData(response.data.results);
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  }, []);

  return loader ? (
    <Loader loading={true} />
  ) : (
    <>
      <Box sx={{ mt: 7 }}>
        <div>
          <Header pageName="Applications Pending" />
        </div>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Box className={classes.boxRoot}>
                <Grid container className="statusGrid">
                  {data.length > 0 ? (
                    data.map((item: any, index: number) => {
                      return (
                        <Grid
                          item
                          xs={12}
                          key={index}
                          onClick={() =>
                            history.push("/check-eligibility", {
                              application_id: item.application_id,
                            })
                          }
                        >
                          <SimpleCard
                            heading="Pending"
                            username={item["Username"]}
                            userID={item["User ID"]}
                            productName={item["Product Name"]}
                            color="#FE7C7C"
                          />
                        </Grid>
                      );
                    })
                  ) : (
                    <p>No detail found</p>
                  )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
